import {
  getInventoryDate,
  useGetOrder,
  useNextOrder,
} from '@hungryroot/orders';

/**
 * Get the params required to fetch out of stock data for a pairing or product
 * Defaults to using params for the next editable order
 * If orderId is provided, uses params for the requested order
 */
export const usePairingInventoryParams = (orderId?: number) => {
  const { order: nextEditableOrder } = useNextOrder({ enabled: !orderId });
  const { data: requestedOrder } = useGetOrder(orderId, { enabled: !!orderId });

  const effectiveOrder = orderId ? requestedOrder : nextEditableOrder;

  const inventoryParams = effectiveOrder && {
    origin: effectiveOrder.origin,
    inventory_date: getInventoryDate(effectiveOrder),
  };

  return inventoryParams;
};
